import { all, put, take, takeLatest } from 'redux-saga/effects';
import { eventChannel, END } from 'redux-saga';
import constants from 'src/constants';
import notificationDux from '.';

export function countdown(secs) {
  return eventChannel((emitter) => {
    let counter = secs;

    const interval = setInterval(() => {
      counter -= 1;
      if (counter > 0) {
        emitter(counter);
      } else {
        emitter(END);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });
}

export function* handleNotificationSaga(action) {
  const channel = countdown(
    constants.notification.SECONDS_TO_SHOW_NOTIFICATIONS,
  );

  try {
    while (true) {
      yield put(
        notificationDux.actions.setNotification({
          type: action.payload,
          isVisible: true,
        }),
      );
      yield take(channel);
    }
  } finally {
    yield put(
      notificationDux.actions.setNotification({
        type: action.payload,
        isVisible: false,
      }),
    );
  }
}

export default function* sagas() {
  yield all([
    takeLatest(
      notificationDux.actions.handleNotification,
      handleNotificationSaga,
    ),
  ]);
}
